import script from "./AuthorDisplayNameEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorDisplayNameEditor.vue?vue&type=script&setup=true&lang=js"

import "./AuthorDisplayNameEditor.vue?vue&type=style&index=0&id=42d354e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42d354e5"]])

export default __exports__